import React from "react";

// Single icon, colored via `color` instead of the old Scale.svg /
// Scale_red.svg file pair.
const ScaleIcon = ({ color = "#000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="52"
    viewBox="0 0 52 52"
  >
    <polyline
      points="49.83 13 29.25 33.58 18.42 22.75 2.17 39"
      fill="none"
      stroke={color}
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></polyline>
    <polyline
      points="36.83 13 49.83 13 49.83 26"
      fill="none"
      stroke={color}
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></polyline>
  </svg>
);

export default ScaleIcon;
